module.exports = __webpack_public_path__ + "static/007-31b869e7af346dc97265914a5484567f.png";